import apiV2 from "api-v2";
import type {
	RfxReportPreviewHtmlResponse,
	RfxReportExportResponse,
	RfxSummaryPreviewParams,
	RfxResponsePreviewParams,
	EvaluationPreviewParams,
} from "../types";

export const fetchRfxSummaryPreviewHtml = async (
	rfxId: number,
	params: RfxSummaryPreviewParams
): Promise<RfxReportPreviewHtmlResponse> => {
	const response = await apiV2.post(
		`rfq/${rfxId}/report-preview/summary`,
		params
	);
	return response.data.data;
};

export const exportRfxSummaryReport = async (
	rfxId: number
): Promise<RfxReportExportResponse> => {
	const response = await apiV2.get(`rfq/${rfxId}/download-summary`);
	return response.data.data;
};

export const fetchRfxResponsePreviewHtml = async (
	rfxId: number,
	params: RfxResponsePreviewParams
): Promise<RfxReportPreviewHtmlResponse> => {
	const response = await apiV2.post(
		`rfq/${rfxId}/report-preview/response`,
		params
	);
	return response.data.data;
};

export const exportRfxIndividualResponse = async (
	rfxId: number,
	inviteId: number
): Promise<RfxReportExportResponse> => {
	const response = await apiV2.get(
		`rfq/${rfxId}/download-response/${inviteId}`
	);
	return response.data.data;
};

export const exportRfxAllResponses = async (
	rfxId: number
): Promise<RfxReportExportResponse> => {
	const response = await apiV2.get(`rfq/${rfxId}/download-all-responses`);
	return response.data.data;
};

export const fetchSampleResponsePreviewHtml = async (
	params: RfxResponsePreviewParams
): Promise<RfxReportPreviewHtmlResponse> => {
	const response = await apiV2.post("rfq/report-preview/response/sample", params);
	return response.data.data;
};

export const fetchSampleSummaryPreviewHtml = async (
	params: RfxSummaryPreviewParams
): Promise<RfxReportPreviewHtmlResponse> => {
	const response = await apiV2.post("rfq/report-preview/summary/sample", params);
	return response.data.data;
};

export const fetchSampleEvaluationPreviewHtml = async (
	params: EvaluationPreviewParams
): Promise<RfxReportPreviewHtmlResponse> => {
	const response = await apiV2.post("rfq/report-preview/evaluation/sample", params);
	return response.data.data;
};
